import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import ICONS from "@config/icons";
import { selectSearch, setSearch } from "@redux/slices/search";
import { useTranslation } from "next-i18next";

const useActions = (topic: string) => {
  const [fade, setFade] = useState(true);
  const dispatch = useDispatch();
  const search = useSelector(selectSearch);
  const router = useRouter();
  const { t } = useTranslation("faq");

  const dataVariants = [
    {
      title: t("variant.0.title"),
      subTitle: t("variant.0.subtitle"),
      icon: ICONS.ICON_HEADPHONE,
    },
    {
      title: t("variant.1.title"),
      subTitle: t("variant.1.subtitle"),
      icon: ICONS.ICON_WRENCH,
    },
    {
      title: t("variant.2.title"),
      subTitle: t("variant.2.subtitle"),
      icon: ICONS.ICON_INBOX,
    },
  ];

  const breadcrumbs = [{ label: topic }];

  const handleSearch = (values: string) => {
    dispatch(setSearch(values));
    if (values) {
      router.push({
        pathname: router.pathname,
        query: {
          search: values
        }
      });
    } else {
      router.push({ query: {} });
    }
    setFade(!values.length);
  };

  // ** useEffect is handling to clear query params on first load ** //
  useEffect(() => {
    dispatch(setSearch(""));
    const fetchRouter = setTimeout(() => {
      history.replaceState({}, '', router.pathname);
    }, 100);

    return () => window.clearTimeout(fetchRouter);
  }, []);

  return {
    dataVariants,
    search,
    handleSearch,
    fade,
    breadcrumbs,
  };
};

export default useActions;
